import { API_BASE_URL } from "../config/api"

const PLATFORM_MEDIA_BASE = String(process.env.VUE_APP_MEDIA_CDN_URL || "").trim().replace(/\/$/, "")
const PLATFORM_CDN_ORIGIN = PLATFORM_MEDIA_BASE.replace(/\/public\/media$/i, "")
const API_ORIGIN = API_BASE_URL.replace(/\/user\/api$/i, "")

/**
 * 将历史 Web 根目录上传地址指向 ThinkPHP API 主机。
 *
 * 本地开发保留 `/uploads/...`，交给 Vue devServer 代理；生产构建使用
 * VUE_APP_API_BASE_URL 的同一主机，避免浏览器错误地从 H5 静态站点取文件。
 */
export function legacyUploadUrl(value) {
  const url = String(value || "").trim()
  if (!/^\/uploads\/[A-Za-z0-9/_\-.%]+(?:\?[^#]*)?(?:#.*)?$/i.test(url)) return url
  return API_ORIGIN ? `${API_ORIGIN}${url}` : url
}

/**
 * 递归修正接口响应中的历史上传地址；OSS/CDN 与外部 HTTPS 地址保持原样。
 */
export function normalizeResponseMediaUrls(value) {
  if (typeof value === "string") return legacyUploadUrl(value)
  if (Array.isArray(value)) return value.map(item => normalizeResponseMediaUrls(item))
  if (!value || typeof value !== "object") return value

  Object.keys(value).forEach(key => {
    value[key] = normalizeResponseMediaUrls(value[key])
  })
  return value
}

export function platformMediaUrl(path) {
  const normalized = `/${String(path || "").replace(/^\/+/, "")}`
  return PLATFORM_MEDIA_BASE ? `${PLATFORM_MEDIA_BASE}${normalized}` : `/media${normalized}`
}

export const DEFAULT_AVATAR_URL = "https://starlivecdn.xyhy.live/public/media/avatars/default-avatar.svg"

/**
 * 统一修正数据库中的平台素材 URL。
 *
 * 旧等级素材曾使用 livelifecdn 域名；迁移期间客户端仍需兼容缓存中的旧地址。
 * 本地 H5 以 HTTP 运行时使用 CDN 的 HTTP 入口，避免尚未启用 443 的自定义域名导致图片失败；
 * HTTPS 正式站点始终保留 HTTPS，不能产生混合内容。
 */
export function platformAssetUrl(value) {
  let url = String(value || "").trim()
  if (!url) return ""

  url = legacyUploadUrl(url)

  const origin = PLATFORM_CDN_ORIGIN || "https://starlivecdn.xyhy.live"
  url = url.replace(
    /^https?:\/\/livelifecdn\.xyhy\.live\/system\//i,
    `${origin}/public/system/`
  )

  if (typeof window !== "undefined" && window.location.protocol === "http:") {
    url = url.replace(/^https:\/\/(starlivecdn\.xyhy\.live)(?=\/)/i, "http://$1")
  }
  return url
}

/**
 * 所有用户和作者头像统一回退到本地资源，避免空地址或外链失效显示破图。
 */
export function avatarUrl(value) {
  const url = String(value || "").trim()
  return legacyUploadUrl(url) || DEFAULT_AVATAR_URL
}

export function handleAvatarError(event) {
  const image = event && event.target
  if (!image || image.dataset.defaultAvatarApplied === "1") return
  image.dataset.defaultAvatarApplied = "1"
  image.src = DEFAULT_AVATAR_URL
}
